import NewTicketEmailTemplate from './NewTicketEmailTemplate';

export { NewTicketEmailTemplate };
export default NewTicketEmailTemplate;
